import "./Malwarebytes.module.css";
import Header from "@/reusable_sections/Header";
import Vpngenixhero from "./sections/Vpngenixhero";
import Systemshieldfeatures from "./sections/Systemshieldfeatures";
import Benefits from "./sections/Benefits";
import CustomerReviewCarousel from "./sections/CustomerReviewCarousel";
import Footer from "@/reusable_sections/Footer";
export default function MalwarebytesPage() {
  return <div>
      <Header />
      <Vpngenixhero />
      <Systemshieldfeatures />
      <Benefits />
      <CustomerReviewCarousel />
      <Footer />
    </div>;
}